__turbopack_context__.v({
  "Feature": "delhi-prefit-module__RoRyja__Feature",
  "aboutheading1": "delhi-prefit-module__RoRyja__aboutheading1",
  "aboutheading2": "delhi-prefit-module__RoRyja__aboutheading2",
  "aboutheading3": "delhi-prefit-module__RoRyja__aboutheading3",
  "acheiverrank": "delhi-prefit-module__RoRyja__acheiverrank",
  "acheiverranks": "delhi-prefit-module__RoRyja__acheiverranks",
  "acheiverranks1": "delhi-prefit-module__RoRyja__acheiverranks1",
  "addbox": "delhi-prefit-module__RoRyja__addbox",
  "admincontent": "delhi-prefit-module__RoRyja__admincontent",
  "badge": "delhi-prefit-module__RoRyja__badge",
  "bgimage": "delhi-prefit-module__RoRyja__bgimage",
  "bgregclose": "delhi-prefit-module__RoRyja__bgregclose",
  "card": "delhi-prefit-module__RoRyja__card",
  "cardBody": "delhi-prefit-module__RoRyja__cardBody",
  "cardHeader": "delhi-prefit-module__RoRyja__cardHeader",
  "checkboxcontent": "delhi-prefit-module__RoRyja__checkboxcontent",
  "circleGlow": "delhi-prefit-module__RoRyja__circleGlow",
  "classacheiverrank": "delhi-prefit-module__RoRyja__classacheiverrank",
  "contactbox": "delhi-prefit-module__RoRyja__contactbox",
  "contactheader": "delhi-prefit-module__RoRyja__contactheader",
  "contactheader1": "delhi-prefit-module__RoRyja__contactheader1",
  "container": "delhi-prefit-module__RoRyja__container",
  "date": "delhi-prefit-module__RoRyja__date",
  "dayValue": "delhi-prefit-module__RoRyja__dayValue",
  "dayValue1": "delhi-prefit-module__RoRyja__dayValue1",
  "description": "delhi-prefit-module__RoRyja__description",
  "desktopView": "delhi-prefit-module__RoRyja__desktopView",
  "dot": "delhi-prefit-module__RoRyja__dot",
  "facultyborder1": "delhi-prefit-module__RoRyja__facultyborder1",
  "facultyborder2": "delhi-prefit-module__RoRyja__facultyborder2",
  "facultyborder4": "delhi-prefit-module__RoRyja__facultyborder4",
  "featureCard": "delhi-prefit-module__RoRyja__featureCard",
  "featureGrid": "delhi-prefit-module__RoRyja__featureGrid",
  "freebutton": "delhi-prefit-module__RoRyja__freebutton",
  "handicon": "delhi-prefit-module__RoRyja__handicon",
  "head": "delhi-prefit-module__RoRyja__head",
  "heading3d": "delhi-prefit-module__RoRyja__heading3d",
  "heroCard": "delhi-prefit-module__RoRyja__heroCard",
  "item": "delhi-prefit-module__RoRyja__item",
  "mobileView": "delhi-prefit-module__RoRyja__mobileView",
  "muted-placeholder": "delhi-prefit-module__RoRyja__muted-placeholder",
  "newstd": "delhi-prefit-module__RoRyja__newstd",
  "normalbutton": "delhi-prefit-module__RoRyja__normalbutton",
  "pageborder": "delhi-prefit-module__RoRyja__pageborder",
  "pagemaintitle": "delhi-prefit-module__RoRyja__pagemaintitle",
  "paybill": "delhi-prefit-module__RoRyja__paybill",
  "paybill1": "delhi-prefit-module__RoRyja__paybill1",
  "paybutton": "delhi-prefit-module__RoRyja__paybutton",
  "redunderline": "delhi-prefit-module__RoRyja__redunderline",
  "redunderlinealink": "delhi-prefit-module__RoRyja__redunderlinealink",
  "regclose": "delhi-prefit-module__RoRyja__regclose",
  "rotateGlow": "delhi-prefit-module__RoRyja__rotateGlow",
  "scheduletitle": "delhi-prefit-module__RoRyja__scheduletitle",
  "sectionsubtitle": "delhi-prefit-module__RoRyja__sectionsubtitle",
  "sectiontitle": "delhi-prefit-module__RoRyja__sectiontitle",
  "statCircle": "delhi-prefit-module__RoRyja__statCircle",
  "statsRow": "delhi-prefit-module__RoRyja__statsRow",
  "subtext": "delhi-prefit-module__RoRyja__subtext",
  "table": "delhi-prefit-module__RoRyja__table",
  "tableheading": "delhi-prefit-module__RoRyja__tableheading",
  "tablepara": "delhi-prefit-module__RoRyja__tablepara",
  "tablescroll": "delhi-prefit-module__RoRyja__tablescroll",
  "tabletitle": "delhi-prefit-module__RoRyja__tabletitle",
  "tabvalue": "delhi-prefit-module__RoRyja__tabvalue",
  "tesfee": "delhi-prefit-module__RoRyja__tesfee",
  "tesfee1": "delhi-prefit-module__RoRyja__tesfee1",
  "text": "delhi-prefit-module__RoRyja__text",
  "title": "delhi-prefit-module__RoRyja__title",
  "ulclass": "delhi-prefit-module__RoRyja__ulclass",
  "ulliclass": "delhi-prefit-module__RoRyja__ulliclass",
  "ullispan": "delhi-prefit-module__RoRyja__ullispan",
});
